import React from 'react'
import { Accordion, Grid, AccordionItem } from '@mantine/core'
import { Contact } from '../schemas/Contact'

type PersonDetailedBoxProps = {
  contact: Contact
}
export const PersonDetailedBox: React.FC<PersonDetailedBoxProps> = (
  props: PersonDetailedBoxProps
) => {
  const { contact } = props
  return (
    <Accordion chevronPosition='left' defaultValue='1'>
      <AccordionItem value='1'>
        <Accordion.Control>
          <h3>Details</h3>
        </Accordion.Control>
        <Accordion.Panel>
          <div id='contact-collapse' className='p-5'>
            <Grid>
              <Grid.Col span={6}>
                {[
                  {
                    label: 'First Name',
                    value: contact.firstName,
                  },
                  {
                    label: 'Last Name',
                    value: contact.lastName,
                  },
                  {
                    label: 'Job Title',
                    value: contact.jobTitle,
                  },
                  {
                    label: 'Job Function',
                    value: contact.jobFunction,
                  },
                  {
                    label: 'Management Level',
                    value: contact.managementLevel,
                  },
                  {
                    label: 'Email Address',
                    value: contact.emailAddress,
                  },
                  {
                    label: 'LinkedIn',
                    value: contact.linkedin,
                  },
                ].map((item, index) => (
                  <div key={index} className='d-flex mb-3 me-15'>
                    <span className='flex-grow-2 text-muted min-w-150px'>{item.label}</span>
                    <span className='flex-grow-1 fw-bold'>{item.value}</span>
                  </div>
                ))}
              </Grid.Col>
              <Grid.Col span={6}>
                {[
                  {
                    label: 'Phone Number',
                    value: contact.phoneNumber,
                  },
                  {
                    label: 'Mobile Phone',
                    value: contact.mobilePhone,
                  },
                  {
                    label: 'Email Domain',
                    value: contact.emailAddress,
                  },
                  {
                    label: 'City',
                    value: contact.city,
                  },
                  {
                    label: 'State',
                    value: contact.state,
                  },
                  {
                    label: 'Country',
                    value: contact.country,
                  },
                ].map((item, index) => (
                  <div key={index} className='d-flex mb-3 me-10'>
                    <span className='flex-grow-2 text-muted min-w-150px'>{item.label}</span>
                    <span className='flex-grow-1 fw-bold'>{item.value}</span>
                  </div>
                ))}
              </Grid.Col>
            </Grid>
          </div>
        </Accordion.Panel>
      </AccordionItem>
    </Accordion>
  )
}
